import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import 'jquery-ui/ui/widgets/dialog';

const createDialog = (el, title, options = {}) => {
    const {
        height = 150,
        width = 300,
        resize,
        resizable = true,
        closeOnEscape,
        dialogClass,
        create,
        modal = false,
        classes = { 'ui-dialog-titlebar-close': 'icon-close' },
    } = options;

    const dialogOpts = {
        resizable,
        height,
        width,
        title,
        autoOpen : false,
        closeText: '',
        classes,
        resize,
        modal,
    };

    if (closeOnEscape !== undefined) dialogOpts.closeOnEscape = closeOnEscape;
    if (dialogClass) dialogOpts.dialogClass = dialogClass;
    if (create) dialogOpts.create = create;

    $(el).dialog(dialogOpts);
};
export default class PanelComponent extends PureComponent {
    render() {
        const { id, content, title, options } = this.props;

        return (
            <div id={id} ref={el => createDialog(el, title, options)}>
                {content}
            </div>
        );
    }
    static props = {
        id     : PropTypes.string,
        title  : PropTypes.string,
        content: PropTypes.object,
        options: PropTypes.object,
    };
}
